import React from 'react';
import PropTypes from 'prop-types';
import { isNonEmptyString, createCustomPropType } from '../../../js/app/react/validators';

import AdvWorkflow from '../AdvWorkflow/AdvWorkflowContainer';
import YearlySalary from './Steps/YearlySalaryContainer';

const IncomeWorkflowView = ({ branch, workflowId }) => (
  <AdvWorkflow branch={branch} workflowId={workflowId} steps={[YearlySalary]} />
);

IncomeWorkflowView.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
};

export default IncomeWorkflowView;
